<template>
  <div class="delivery-block">
    <header>
      <h3 class="float-left">AGB's</h3>
    </header>
    <b-form-group>
      <b-form-checkbox v-model="checked.seller">Landwirt/Bestandsbetrieb gelesen und akzeptiert</b-form-checkbox>
      <b-form-checkbox v-model="checked.buyer">Käufer gelesen und akzeptiert</b-form-checkbox>
      <b-form-checkbox v-model="checked.transporteur">Transporteur gelesen und akzeptiert</b-form-checkbox>
      <a href="test.pdf" target="_blank">AGB's lesen</a>
    </b-form-group>
  </div>
</template>

<script>
import {ref, watch} from '@vue/composition-api'
export default {
  name: "DeliveryTerms",
  setup(_, {emit}) {
    const checked = ref({seller: false, transporteur: false, buyer: false});
    const pdf = ref(null);
    watch(checked, () =>  {
      const valid = checked.value.transporteur && checked.value.seller && checked.value.buyer;
      emit('valid', valid);
    }, {deep: true});

    return {
      checked,
      pdf
    }
  }
}
</script>

<style scoped>

</style>
